var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 11.3782H17.4996V13.7116H10.4996V11.3782ZM16.0915 0.636719L13.9996 2.72855L11.9078 0.636719L10.2581 2.28639L12.35 4.37822L10.2581 6.47005L11.9078 8.11972L13.9996 6.02789L16.0915 8.11972L17.7411 6.47005L15.6493 4.37822L17.7411 2.28639L16.0915 0.636719ZM19.833 13.7116H26.833V11.3782H19.833V13.7116ZM27.0745 2.28639L25.4248 0.636719L23.333 2.72855L21.2411 0.636719L19.5915 2.28639L21.6833 4.37822L19.5915 6.47005L21.2411 8.11972L23.333 6.02789L25.4248 8.11972L27.0745 6.47005L24.9826 4.37822L27.0745 2.28639ZM1.1663 13.7116H8.16631V11.3782H1.1663V13.7116ZM6.75814 0.636719L4.66631 2.72855L2.57447 0.636719L0.924805 2.28639L3.01664 4.37822L0.924805 6.47005L2.57447 8.11972L4.66631 6.02789L6.75814 8.11972L8.4078 6.47005L6.31597 4.37822L8.4078 2.28639L6.75814 0.636719Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordSetting);
export default __webpack_public_path__ + "static/media/password-setting.f7988ca7dbfb786e97259d9fcb876d55.svg";
export { ForwardRef as ReactComponent };